import React, { FC, SyntheticEvent } from "react";
import { AlertColor, Snackbar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

import { createPortal } from "react-dom";

interface NotificationProps {
  isOpen: boolean;
  message: any;
  severity: AlertColor;
  autoHideDuration?: number | null;
  closeNotification: (value: boolean) => void;
  onClose?: any
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Notification: FC<NotificationProps> = ({
  isOpen,
  message,
  severity,
  autoHideDuration,
  closeNotification,
  onClose
}) => {
  let duration: number | null = 2000;

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    closeNotification(false);
  };

  if (autoHideDuration !== undefined) {
    duration = autoHideDuration;
  }
  if (!isOpen) return null;
  return createPortal(
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={isOpen}
      autoHideDuration={duration}
      onClose={handleClose}
      onClick={() => {
        onClose && onClose(); 
        handleClose();
     }}
      sx={{ whiteSpace: 'break-spaces' }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>,
    document.body
  );
};

export default Notification;
